
/* injects from baggage-loader */

'use strict';

import ProductsComponent from './products.component';

const ProductsPageModule = angular.module('products-module', [
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('products', {
        url: '/products',
        component: 'products',
        data: {
          title: 'My Products'
        },
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          products: function (Product) {
            return Product.query({
              select: ['name', 'updatedAt', 'status'],
              // Hide product children from the main list
              equalTo: { key: 'parent', value: null }
            });
          }
        },
        parentNavBar: [
          {
            title: 'Products',
            icon: 'fa-th-list',
            state: 'products'
          },
          // {
          //   title: 'Document Requests',
          //   icon: 'fa-file-text',
          //   state: 'account.document-requests'
          // },
          {
            title: 'Service Updates',
            icon: 'fa-wrench',
            state: 'service-updates'
          },
          {
            title: 'Product Groups',
            icon: 'fa-th',
            state: 'product-groups'
          }
        ]
      });
  })
  .component('products', new ProductsComponent());

export default ProductsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/products/products.module.js